<template>
  <div
    ref="elRef"
    class="flex text-white p-2 items-center rounded-lg cursor-pointer"
    :class="{ 'bg-[#306aff]': active }"
    @click="
      clickEvent();
      handleVideo(video);
    "
  >
    <div class="pr-2 text-13 w-4 flex-shrink-0">
      <span v-if="active" class="text-xs">&#x25B6;</span>
      <span v-else>{{ index + 1 }}</span>
    </div>
    <OImage :src="video.thumbnailUrl" class="w-[106px] h-15 rounded object-cover flex-shrink-0" />
    <p class="text-13 line-clamp-3 ml-2 font-semibold">
      {{ video.title }}
    </p>
  </div>
</template>

<script>
import { defineComponent, inject, onBeforeUnmount } from '@nuxtjs/composition-api';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import { useDevice } from '~/composables/useDevice';
import { OImage } from '~/modules/common/components/ui';
import { eventBus } from '~/modules/common/utils/eventBus';

export default defineComponent({
  components: { OImage },
  props: {
    video: {
      type: Object,
      require: true,
    },
    index: {
      type: Number,
      require: true,
    },
    active: {
      type: Boolean,
      require: false,
    },
  },
  setup(props, { emit }) {
    // const { $analyticsEvent } = useContext();
    const { isMobile } = useDevice();
    const handleVideo = (video) => {
      if (isMobile.value) {
        window.scrollTo({
          top: 200,
        });
      }
      // $analyticsEvent('Video_Page', 'User_Engagement', 'click_nextVideo_' + (props.index + 1));
      emit('selected-video', video);
    };

    // trigger from ended video
    eventBus.on('article-video-ended', (index, video) => {
      if (index === props.index) {
        clickEvent();
      }
    });

    onBeforeUnmount(() => {
      eventBus.off('article-video-ended');
    });

    const article = inject('article');
    // Data Layer Impression & Click
    const { sendDataLayer } = useTracking();
    const { elRef, clickEvent } = sendDataLayer(
      {
        item: article,
        list: 'Video Detay - İçeriğin Videoları',
        position: parseInt(props.index) + 1,
      },
      ['scroll', 'click']
    );

    return { handleVideo, elRef, clickEvent };
  },
});
</script>
